import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式

// 全局弹出框
import {rv_dialog} from './utils/DialogUtils.js'
// 公共方法
import {rv_common} from './utils/common.js'
// 动效
import 'wowjs/css/libs/animate.css'

Vue.prototype.$rv_dialog = rv_dialog
Vue.prototype.$rv_common = rv_common

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})

Vue.use(ElementUI); // 3.安装



// WEBPACK FOOTER //
// ./src/main.js